import initialState from '../store/initial-state'
import {
  ASSET_EXPLORE_UPLOAD_GET_DATA,
  ASSET_EXPLORE_UPLOAD_GET_DATA_SUCCESS,
  ASSET_EXPLORE_UPLOAD_GET_DATA_FAILURE,
  CLEAN_DATA_BACK
} from '../constants/assets-explore-upload-types'

export default (state = initialState.assetsExploreUpload, action) => {
  switch (action.type) {
    case ASSET_EXPLORE_UPLOAD_GET_DATA:
      return {
        ...state,
        folderselect: action.payload.folder,
        isFetching: action.payload.isFetching,
        data: action.payload.data,
        // folderselect: action.payload,
        // isFetching: true,
        // data: [],
        error: null
      }

    case ASSET_EXPLORE_UPLOAD_GET_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.user.clientRole === 'admin' || action.payload.user.role === 'admin'
          ? action.payload.data
          : action.payload.data.filter(r => r.group.length > 0 || r.isShared),
        dataBack: action.payload.user.clientRole === 'admin' || action.payload.user.role === 'admin'
          ? [...state.dataBack, ...action.payload.data]
          : [...state.dataBack, ...action.payload.data.filter(r => r.group.length > 0 || r.isShared)],
        headers: action.payload.headers,
        page: action.payload.page,
        limit: action.payload.limit,
        orderBy: action.payload.orderBy,
        tagProtocol: action.payload.tagProtocol,
        longDescription: action.payload.longDescription,
        error: null

      }

    case ASSET_EXPLORE_UPLOAD_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: [],
        error: action.payload
      }
    case CLEAN_DATA_BACK:
      return {
        ...state,
        dataBack: []
      }
    default: return { ...state }

  }

}
